<template>
  <div class="row mr-2">
    <v-spacer></v-spacer>
    <v-file-input
      style="margin-top: 10px"
      :label="uploadFieldLabel"
      ref="file"
      @change="fileUpload()"
      single-line
      hide-details
    ></v-file-input>
    <v-btn @click="submitFile()" :disabled="!file" class="ma-2" outlined :color="color">Upload</v-btn>
  </div>
</template>
<script>
export default {
  props: {
    uploadFieldLabel: {
      type: String,
      default: 'Select file'
    },
    inputName: {
      type: String,
      default: 'file'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data () {
    return {
      file: null
    }
  },
  methods: {
    // Upload file on component
    fileUpload () {
      this.file = this.$refs.file.lazyValue
    },

    // Upload to BE
    submitFile () {
      console.log('submitFile')
      let formData = new FormData()
      if (this.file.name) {
        formData.append(this.inputName, this.file)
        this.$emit('file-submitted', formData)
        // apiService.uploadNpos(formData)
      }
    }
  }
}
</script>
